import { render } from "./renderForm.vue?vue&type=template&id=a4533092&scoped=true"
import script from "./renderForm.vue?vue&type=script&lang=js"
export * from "./renderForm.vue?vue&type=script&lang=js"

import "./renderForm.vue?vue&type=style&index=0&id=a4533092&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4533092"]])

export default __exports__